import React from 'react';
import { GECKO_CONSTS, GeckoAlert } from 'ui';

const GeckoErrorsAlert = ({ name, errors }) => {
  if (!errors || !errors.length) {
    return null;
  }
  return (
    <GeckoAlert aria-label={name} type={GECKO_CONSTS.ALERT_TYPE_DANGER}>
      <ul>
        {errors.map((error, index) => {
          return (
            <li key={index}>
              {error.title}: {error.detail}
            </li>
          );
        })}
      </ul>
    </GeckoAlert>
  );
};

export default GeckoErrorsAlert;
